import { Route, Routes } from 'react-router-dom';
import './App.css';
import ClientRegister from './component/ClientRegister';
import Addtesttoclient from './pages/Addtesttoclient';
import Adminactions from './pages/Adminactions';
import Assigncredits from './pages/Assigncredits';
import Assigntest from './pages/Assigntest';
import Bookingdetails from './pages/Bookingdetails';
import BillReset from './pages/BillReset';
import CancelTest from './pages/CancelTest';
import ClientTestwisedata from './pages/ClientTestwisedata';
import ClientRefById from './pages/ClientRefById';
import ForgotPassword from './pages/ForgotPassword';
import Login from './pages/Login';
import OnBoardingData from './pages/OnBoardingData';
import Outsourcepage from './pages/Outsourcepage';
import SalesPerformance from './pages/SalesPerformance';
import Testwisedata from './pages/TestWisedata';
import Testwiseregistrationdata from './pages/Testwiseregistrationdata';
import TestProfileManagement from './pages/TestProfileManagement';
import UpdateTestConfigPage from './pages/UpdateTestConfigPage';
import Totalbooking from './pages/Totalbooking';

function App() {
  return (
    <div className="App">
    
      <Routes>
      <Route path="/login" element={<Login/>} />
        
       
        <Route path="/forgot-password" element={<ForgotPassword/>} />
        <Route path="/" element={<Totalbooking/>} />
        <Route path="/onboardclient" element={<ClientRegister/>} />
        <Route path="/client-refbyid" element={<ClientRefById/>} />
        <Route path='/total-booking' element={<Totalbooking/>}/>
        <Route path='/test-data' element={<Testwisedata/>}/>
        <Route path='/test-data/registration' element={<Testwiseregistrationdata/>}/>
        <Route path='/test-data-clientwise' element={<ClientTestwisedata/>}/>
        <Route path='/onboareding-data' element={<OnBoardingData/>}/>
        <Route path='/bookingdetail' element={<Bookingdetails/>}/>
        <Route path='/bill-reset' element={<BillReset/>}/>
        <Route path='/assigncredits' element={<Assigncredits/>}/>
        <Route path='/cancel-test' element={<CancelTest/>}/>
        <Route path='/cancel-test/:orderId' element={<CancelTest/>}/>
       <Route path='/assigntest' element={<Assigntest/>}/>
       <Route path='/test-profile-management' element={<TestProfileManagement/>}/>
       <Route path='/update-test-config' element={<UpdateTestConfigPage/>}/>
       <Route path='/testdetails' element={<Addtesttoclient/>}/>
       <Route path='/adminactions' element={<Adminactions/>}/>
       <Route path='/sales-performance' element={<SalesPerformance/>}/>
       {/* <Route path='/testdetailslab' element={<Changelabwise/>}/> */}
       <Route path='/outsource/registration' element={<Outsourcepage/>}/>
      </Routes>
    </div>
  );
}

export default App;
